// use Symbol here to make vuetify to catch this key. Vuetify lib is waiting only for Symbol type key
export const VUETIFY_DEFAULTS_KEY = Symbol.for("vuetify:defaults");

export const PIP_ROOT_CLASS = "pip-root";
